import { FilterOption } from 'src/types/FilterGroup';

export default function addTitleToGuid(option: FilterOption): string {
	return option.title.replaceAll(' ', '-') + '_' + option.id;
}
